import { FormattedMessage } from "react-intl";
import { Link } from "@react-navigation/native";
import { ActivityIndicator } from "react-native";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import { SCREENS } from "navigation/consts";
import {
  EventType,
  TicketStatus,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";

import * as Styled from "./styles";
import TicketBox from "./partials/TicketBox";
import {
  useTicket,
  useTicketDetailsRouteParams,
  useTicketStatus,
} from "./hooks";

const TicketDetails: React.FC = () => {
  const { eventOccurrenceId, ticketId } = useTicketDetailsRouteParams();
  const { ticket, loading } = useTicket();
  const {
    loading: updating,
    setTicketStatusNew,
    setTicketStatusScanned,
    setAllTicketStatusScanned,
  } = useTicketStatus(ticketId, ticket?.orderId, eventOccurrenceId);

  if (loading) {
    return <ActivityIndicator />;
  }

  if (!ticket) {
    return (
      <Text textAlign="center" margin="2rem">
        <FormattedMessage defaultMessage="Ticket not found" />
      </Text>
    );
  }

  const { event } = ticket?.ticketPool || {};

  return (
    <Styled.Wrapper>
      <TicketBox {...ticket} />
      <Styled.Actions>
        {eventOccurrenceId && (
          <Link
            to={{
              screen: SCREENS.Main,
              params: { eventOccurrenceId },
            }}
          >
            <Button type="button" $mode="tertiary" size="large" $fullW>
              <FormattedMessage defaultMessage="Go to Guest List" />
            </Button>
          </Link>
        )}
        {ticket.status === TicketStatus.NEW && (
          <>
            <Button
              type="button"
              $mode="tertiary"
              size="large"
              $fullW
              disabled={updating}
              onClick={setTicketStatusScanned}
            >
              <FormattedMessage defaultMessage="Check-in" />
            </Button>
            {event?.type === EventType.NONTICKETED && (
              <Button
                type="button"
                $mode="tertiary"
                size="large"
                $fullW
                disabled={updating}
                onClick={setAllTicketStatusScanned}
              >
                <FormattedMessage defaultMessage="Check-In All From Order" />
              </Button>
            )}
          </>
        )}
        {ticket.status === TicketStatus.SCANNED && (
          <Button
            type="button"
            $mode="tertiary"
            size="large"
            $fullW
            disabled={updating}
            onClick={setTicketStatusNew}
          >
            <FormattedMessage defaultMessage="Reverse Check-In" />
          </Button>
        )}
      </Styled.Actions>
    </Styled.Wrapper>
  );
};

export default TicketDetails;
